import { useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

export default function Tutorial() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-[#04060d] text-slate-100">
      <div className="max-w-5xl mx-auto px-4 py-8 space-y-5">
        <button
          onClick={() => navigate('/dashboard')}
          className="inline-flex items-center gap-2 text-cyan-300 hover:text-cyan-200"
        >
          <ChevronLeft size={16} /> Volver al Dashboard
        </button>

        <div className="rounded-2xl border border-cyan-500/30 bg-gradient-to-b from-[#091225] to-[#060a14] p-5">
          <h1 className="text-3xl font-bold text-cyan-300">Tutorial de TerranWar (Fase Actual)</h1>
          <p className="mt-2 text-slate-300 text-sm">
            Esta guía cubre todo lo que ya está activo en el juego ahora mismo. La iremos ampliando en siguientes fases.
          </p>
        </div>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">1. Registro, verificación y acceso</h2>
          <p className="text-sm text-slate-300">1. Te registras con usuario, email y contraseña.</p>
          <p className="text-sm text-slate-300">2. Recibes código de 4 dígitos por email.</p>
          <p className="text-sm text-slate-300">3. Debes verificar el email en la pantalla de verificación antes de iniciar sesión.</p>
          <p className="text-sm text-slate-300">4. Si no tienes el código, puedes reenviarlo desde la misma pantalla.</p>
        </section>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">2. Onboarding y creación del BOT</h2>
          <p className="text-sm text-slate-300">1. Primer acceso: protocolo de despliegue con historia inicial.</p>
          <p className="text-sm text-slate-300">2. Selección de clan o neutral.</p>
          <p className="text-sm text-slate-300">3. Configuración de BOT (nombre y distribución de puntos de armadura).</p>
          <p className="text-sm text-slate-300">4. Se crea el BOT inicial y quedas listo para operar.</p>
        </section>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">3. Dashboard y panel táctico</h2>
          <p className="text-sm text-slate-300">1. Ves estado general del piloto y BOT.</p>
          <p className="text-sm text-slate-300">2. Acceso a despliegue, ciudad, inventario del BOT y módulos en progreso.</p>
          <p className="text-sm text-slate-300">3. Monitor táctico con sector, coordenada y oro.</p>
        </section>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">4. Inventario y armamento del BOT</h2>
          <p className="text-sm text-slate-300">1. Puedes equipar armas en los slots activos del BOT.</p>
          <p className="text-sm text-slate-300">2. Un mismo arma no debe duplicarse en varios slots sin stock real.</p>
          <p className="text-sm text-slate-300">3. La munición se maneja por disparos internos y se traduce a cargadores completos para venta.</p>
        </section>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">5. Ciudad y servicios urbanos</h2>
          <p className="text-sm text-slate-300">1. Nodo urbano con módulos: tienda, taller, hangar, almacén, transporte y terrenos.</p>
          <p className="text-sm text-slate-300">2. Tienda con catálogo, buscador, categorías y carrito de compra/venta.</p>
          <p className="text-sm text-slate-300">3. Taller operativo para reparación del BOT.</p>
          <p className="text-sm text-slate-300">4. Módulos avanzados (hangar/almacén/terrenos) preparados para expansión por fases.</p>
        </section>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">6. Reglas de clan y acceso a ciudades</h2>
          <p className="text-sm text-slate-300">1. Piloto neutral puede entrar a ciudad de clan pagando cuota de entrada aleatoria (máximo 5 oro).</p>
          <p className="text-sm text-slate-300">2. Neutral en ciudad de clan: puede vender, usar taller y transporte; no puede comprar armas/munición ni usar hangar/almacén/terrenos.</p>
          <p className="text-sm text-slate-300">3. Piloto de clan no neutral: tiene prohibida la entrada a ciudades de otros clanes.</p>
        </section>

        <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5 space-y-2">
          <h2 className="text-cyan-300 font-bold">7. Tienda y munición (estado actual)</h2>
          <p className="text-sm text-slate-300">1. El panel muestra oro disponible para decidir compras.</p>
          <p className="text-sm text-slate-300">2. Venta de munición por cargadores completos.</p>
          <p className="text-sm text-slate-300">3. Si sobran balas sueltas, no se venden, pero no bloquean la venta de cargadores completos.</p>
        </section>
      </div>
    </div>
  )
}
